/* ============================================================
   Pawmento — logica temei
   1) stepper de cantitate
   2) adaugare in cos prin AJAX + redirect in checkout
      (fara JS, formularul face acelasi lucru prin POST + return_to)
   3) contorul din antet
   ============================================================ */
(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }

  function initBuy(section) {
    var form = section.querySelector("[data-add-form]");
    if (!form) return;

    var qtyInput = form.querySelector("[data-qty-input]");
    form.querySelectorAll("[data-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (!qtyInput) return;
        var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10);
        qtyInput.value = Math.max(1, next);
      });
    });

    var btn = form.querySelector("[data-add-btn]");
    var err = form.querySelector("[data-err]");

    form.addEventListener("submit", function (e) {
      var idField = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      if (!idField || !idField.value) return; // lasam submit-ul clasic

      e.preventDefault();
      var original = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.textContent = "Se adaugă…"; }
      if (err) err.classList.remove("on");

      fetch(root() + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: Number(idField.value), quantity: qtyInput ? Number(qtyInput.value) || 1 : 1 }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || "eroare");
          return refreshDrawer(true);
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          if (err) {
            err.textContent = "Nu am putut adăuga produsul. Mai încearcă o dată.";
            err.classList.add("on");
          }
        });
    });
  }

  function refreshCartCount() {
    var el = document.querySelector("[data-cart-count]");
    if (!el) return;
    fetch(root() + "cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) { el.removeAttribute("hidden"); }
        else { el.setAttribute("hidden", ""); }
      })
      .catch(function () {});
  }

  /* ---------- sertarul de cos ---------- */
  function drawerEl() { return document.querySelector("[data-cart-drawer]"); }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.classList.add("no-scroll");
    var x = d.querySelector(".cd-x");
    if (x) x.focus();
  }

  function closeDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");
  }

  // re-randam sertarul din Liquid, ca preturile sa fie mereu corecte
  function refreshDrawer(open) {
    return fetch(root() + "?sections=cart-drawer")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data["cart-drawer"];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-cart-drawer]");
        var current = drawerEl();
        if (fresh && current) {
          var wasOpen = current.classList.contains("is-open");
          current.replaceWith(fresh);
          bindDrawer();
          if (wasOpen || open) openDrawer();
        }
        refreshCartCount();
      })
      .catch(function () { window.location.href = root() + "cart"; });
  }

  function bindDrawer() {
    var d = drawerEl();
    if (!d) return;
    d.querySelectorAll("[data-cart-close]").forEach(function (b) {
      b.addEventListener("click", closeDrawer);
    });
    d.querySelectorAll("[data-cart-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        b.disabled = true;
        fetch(root() + "cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: Number(b.dataset.cartQty), quantity: Number(b.dataset.to) })
        }).then(function () { return refreshDrawer(false); });
      });
    });
  }

  function initSticky() {
    var sticky = document.querySelector("[data-sticky]");
    if (!sticky) return;

    var primary = document.querySelector("[data-buy-primary] [data-add-btn]");
    if (!primary || !("IntersectionObserver" in window)) {
      sticky.classList.add("is-on");
      return;
    }
    // bara apare doar cand butonul principal nu e pe ecran
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle("is-on", !entries[0].isIntersecting);
    }, { rootMargin: "0px 0px -10% 0px" }).observe(primary);
  }

  function initGallery() {
    var g = document.querySelector("[data-gallery]");
    if (!g) return;
    var track = g.querySelector("[data-gallery-track]");
    var dots = g.querySelectorAll("[data-gallery-dots] .dot");
    var thumbs = g.querySelectorAll("[data-thumb]");
    if (!track) return;

    function setActive(i) {
      dots.forEach(function (d, n) { d.classList.toggle("is-on", n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle("is-on", n === i); });
    }

    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(i, dots.length - 1)));
        ticking = false;
      });
    }, { passive: true });

    g.querySelectorAll("[data-gnav]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var step = parseInt(btn.dataset.gnav, 10) * track.clientWidth;
        track.scrollBy({ left: step, behavior: "smooth" });
      });
    });

    thumbs.forEach(function (t, n) {
      t.addEventListener("click", function (e) {
        e.preventDefault();
        track.scrollTo({ left: track.clientWidth * n, behavior: "smooth" });
        setActive(n);
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-buy]").forEach(initBuy);

    initSticky();
    initGallery();

    refreshCartCount();
    bindDrawer();

    var cartLink = document.querySelector(".cart-link");
    if (cartLink) {
      cartLink.addEventListener("click", function (e) {
        if (!drawerEl()) return;
        e.preventDefault();
        refreshDrawer(true);
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeDrawer();
    });

    document.querySelectorAll(".drawer-panel a").forEach(function (a) {
      a.addEventListener("click", function () {
        var d = a.closest("details.drawer");
        if (d) d.open = false;
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", boot);
})();
